import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Check, Clock, X, UserCheck, ChevronRight, AlertCircle } from 'lucide-react';
import api from '../../api/client';

const fmtData = (d) => d ? new Date(d).toLocaleDateString('it-IT') : '—';

const STATO_CONFIG = {
  PENDENTE:  { color:'#F59E0B', bg:'#F59E0B20', icon:Clock,     label:'In attesa di approvazione' },
  APPROVATA: { color:'#22C55E', bg:'#22C55E20', icon:UserCheck,  label:'Richiesta approvata — sei socio!' },
  RIFIUTATA: { color:'#EF4444', bg:'#EF444420', icon:X,          label:'Richiesta non accettata' },
};

const EMPTY = {
  nome:'', cognome:'', codice_fiscale:'', data_nascita:'', luogo_nascita:'',
  indirizzo:'', cap:'', citta:'', provincia:'', telefono:'',
  tipo_richiesto:'ORDINARIO',
  accetta_statuto:false, accetta_privacy:false, accetta_immagini:false,
  note_utente:'',
};

export default function RichiestaSocioPage() {
  const { user } = useAuth();
  const [richiesta, setRichiesta] = useState(null);
  const [loading, setLoading]     = useState(true);
  const [form, setForm]           = useState(EMPTY);
  const [saving, setSaving]       = useState(false);
  const [msg, setMsg]             = useState('');

  const inp = { background:'var(--bg-input)',border:'1px solid var(--border2)',borderRadius:'8px',padding:'9px 12px',color: 'var(--text)',fontSize: 'var(--font-size-sm)',outline:'none',width:'100%',boxSizing:'border-box' };
  const lab = { fontSize: 'var(--font-size-xs)',letterSpacing:'2px',fontWeight:'700',color:'#555',display:'block',marginBottom:'4px' };

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get('/richiesta-socio/mia');
      setRichiesta(r.data);
      if (r.data) setForm({ ...EMPTY, ...r.data, data_nascita: r.data.data_nascita?.slice(0,10)||'' });
    } catch { setRichiesta(null); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const invia = async (e) => {
    e.preventDefault();
    if (!form.accetta_statuto || !form.accetta_privacy) {
      setMsg('Devi accettare lo Statuto e l\'informativa privacy per procedere.'); return;
    }
    setSaving(true);
    try {
      await api.post('/richiesta-socio/mia', form);
      setMsg('Richiesta inviata! Riceverai una risposta dall\'associazione.');
      setTimeout(()=>setMsg(''), 4000);
      load();
    } catch(err) {
      setMsg('✗ ' + (err.response?.data?.error || 'Errore invio'));
      setTimeout(()=>setMsg(''), 4000);
    } finally { setSaving(false); }
  };

  if (loading) return <div style={{ padding:'40px',color:'#555' }}>Caricamento...</div>;

  const statoConf = richiesta ? STATO_CONFIG[richiesta.stato] : null;
  const puoReinviare = richiesta?.stato === 'RIFIUTATA';
  const mostraForm   = !richiesta || puoReinviare;

  return (
    <div style={{ maxWidth:'720px', margin:'0 auto', padding:'0 0 40px' }}>
      {msg && (
        <div style={{ position:'fixed',top:'20px',right:'20px',background:'#22C55E',color:'#fff',padding:'12px 20px',borderRadius:'8px',fontWeight:'700',fontSize: 'var(--font-size-sm)',zIndex:9999 }}>
          {msg}
        </div>
      )}

      <h1 style={{ fontFamily:"'Barlow Condensed'",fontSize: 'var(--font-size-title)',fontWeight:'800',letterSpacing:'2px',marginBottom:'6px' }}>
        ISCRIZIONE A SOCIO
      </h1>
      <p style={{ color:'#666',fontSize: 'var(--font-size-sm)',marginBottom:'24px' }}>
        Associazione Sportiva Dilettantistica B-Cheers Beach Volley Team
      </p>

      {/* STATUS richiesta esistente */}
      {richiesta && (
        <div style={{ background: statoConf.bg, border:`1px solid ${statoConf.color}40`, borderRadius:'12px', padding:'16px 20px', marginBottom:'24px', display:'flex', alignItems:'flex-start', gap:'14px' }}>
          <statoConf.icon size={22} color={statoConf.color} style={{ flexShrink:0, marginTop:'2px' }}/>
          <div style={{ flex:1 }}>
            <div style={{ fontWeight:'800', color:statoConf.color, fontSize: 'var(--font-size-sm)', marginBottom:'4px' }}>{statoConf.label}</div>
            <div style={{ fontSize: 'var(--font-size-xs)', color:'#888' }}>Domanda inviata il {fmtData(richiesta.created_at)}</div>
            {richiesta.stato === 'APPROVATA' && (
              <div style={{ marginTop:'8px', fontSize: 'var(--font-size-sm)', color:'#22C55E' }}>
                Approvata il {fmtData(richiesta.approvata_il)} — benvenuto/a nell'associazione!
              </div>
            )}
            {richiesta.stato === 'RIFIUTATA' && richiesta.note_admin && (
              <div style={{ marginTop:'8px', background:'#EF444415', borderRadius:'6px', padding:'8px 12px', fontSize: 'var(--font-size-xs)', color:'#EF4444' }}>
                <strong>Motivazione:</strong> {richiesta.note_admin}
              </div>
            )}
            {puoReinviare && (
              <div style={{ marginTop:'10px', fontSize: 'var(--font-size-xs)', color:'#888' }}>
                Puoi correggere i dati e reinviare la richiesta qui sotto.
              </div>
            )}
          </div>
        </div>
      )}

      {/* Se già socio approvato, non mostrare il form */}
      {richiesta?.stato === 'APPROVATA' && (
        <div style={{ background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'12px', padding:'24px', textAlign:'center' }}>
          <UserCheck size={40} color='#22C55E' style={{ marginBottom:'12px' }}/>
          <div style={{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-xl)', fontWeight:'800', color:'#22C55E', marginBottom:'8px' }}>
            SEI UN SOCIO B-CHEERS ASD
          </div>
          <p style={{ color:'#666', fontSize: 'var(--font-size-sm)' }}>
            La tua iscrizione è attiva. Per qualsiasi necessità contatta la segreteria.
          </p>
        </div>
      )}

      {/* Se in attesa */}
      {richiesta?.stato === 'PENDENTE' && (
        <div style={{ background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'12px', padding:'24px' }}>
          <div style={{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-lg)', fontWeight:'800', letterSpacing:'2px', color:'#F59E0B', marginBottom:'14px' }}>
            DATI INVIATI
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px' }}>
            {[['Cognome', 'cognome'],['Nome', 'nome'],['Codice Fiscale', 'codice_fiscale'],['Data nascita', 'data_nascita'],['Comune nascita', 'luogo_nascita'],['Telefono', 'telefono'],['Indirizzo', 'indirizzo'],['Città', 'citta'],['Tipo richiesto', 'tipo_richiesto']].map(([l,k]) => (
              richiesta[k] ? (
                <div key={k}>
                  <div style={{ fontSize: 'var(--font-size-xs)',letterSpacing:'1px',fontWeight:'700',color:'var(--text-dim)' }}>{l}</div>
                  <div style={{ fontSize: 'var(--font-size-sm)',color:'var(--text)',marginTop:'2px' }}>{k==='data_nascita'?fmtData(richiesta[k]):richiesta[k]}</div>
                </div>
              ) : null
            ))}
          </div>
          <div style={{ marginTop:'16px', display:'flex', gap:'12px', fontSize: 'var(--font-size-xs)', color:'#666' }}>
            <span style={{ color: richiesta.accetta_statuto?'#22C55E':'#EF4444' }}>{richiesta.accetta_statuto?'✓':'✗'} Statuto</span>
            <span style={{ color: richiesta.accetta_privacy?'#22C55E':'#EF4444' }}>{richiesta.accetta_privacy?'✓':'✗'} Privacy</span>
            <span style={{ color: richiesta.accetta_immagini?'#22C55E':'#EF4444' }}>{richiesta.accetta_immagini?'✓':'✗'} Immagini</span>
          </div>
        </div>
      )}

      {/* FORM (nuovo o reinvio) */}
      {mostraForm && (
        <form onSubmit={invia} style={{ background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'12px', padding:'24px', display:'flex', flexDirection:'column', gap:'0' }}>
          <div style={{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-lg)', fontWeight:'800', letterSpacing:'2px', color:'#F4600C', marginBottom:'20px' }}>
            {puoReinviare ? 'REINVIA DOMANDA DI ISCRIZIONE' : 'DOMANDA DI ISCRIZIONE A SOCIO'}
          </div>

          {/* Intro */}
          <div style={{ background:'#F4600C10', border:'1px solid #F4600C20', borderRadius:'8px', padding:'12px 16px', marginBottom:'20px', fontSize: 'var(--font-size-xs)', color:'#aaa', lineHeight:'1.6' }}>
            <AlertCircle size={13} style={{ verticalAlign:'middle', marginRight:'6px', color:'#F4600C' }}/>
            Compila il modulo per richiedere l'iscrizione all'ASD B-Cheers Beach Volley Team.
            La tua richiesta sarà valutata dal Consiglio Direttivo che ti darà conferma via email.
            La quota associativa viene comunicata dalla segreteria al momento dell'accettazione.
          </div>

          {/* Dati anagrafici */}
          <div style={{ fontSize: 'var(--font-size-xs)',letterSpacing:'2px',fontWeight:'700',color:'#555',marginBottom:'12px' }}>DATI ANAGRAFICI</div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px', marginBottom:'20px' }}>
            <div><label style={lab}>COGNOME *</label><input style={inp} value={form.cognome} onChange={e=>setForm(f=>({...f,cognome:e.target.value}))} required/></div>
            <div><label style={lab}>NOME *</label><input style={inp} value={form.nome} onChange={e=>setForm(f=>({...f,nome:e.target.value}))} required/></div>
            <div><label style={lab}>CODICE FISCALE</label><input style={inp} value={form.codice_fiscale} onChange={e=>setForm(f=>({...f,codice_fiscale:e.target.value.toUpperCase()}))} maxLength={16}/></div>
            <div><label style={lab}>DATA DI NASCITA</label><input type="date" style={inp} value={form.data_nascita} onChange={e=>setForm(f=>({...f,data_nascita:e.target.value}))}/></div>
            <div><label style={lab}>COMUNE DI NASCITA</label><input style={inp} value={form.luogo_nascita} onChange={e=>setForm(f=>({...f,luogo_nascita:e.target.value}))}/></div>
            <div><label style={lab}>TELEFONO *</label><input style={inp} value={form.telefono} onChange={e=>setForm(f=>({...f,telefono:e.target.value}))} required/></div>
            <div style={{ gridColumn:'1/-1' }}><label style={lab}>INDIRIZZO DI RESIDENZA</label><input style={inp} value={form.indirizzo} onChange={e=>setForm(f=>({...f,indirizzo:e.target.value}))}/></div>
            <div><label style={lab}>CITTÀ</label><input style={inp} value={form.citta} onChange={e=>setForm(f=>({...f,citta:e.target.value}))}/></div>
            <div><label style={lab}>PROV.</label><input style={{ ...inp,maxWidth:'80px' }} value={form.provincia} maxLength={2} onChange={e=>setForm(f=>({...f,provincia:e.target.value.toUpperCase()}))}/></div>
          </div>

          {/* Tipo */}
          <div style={{ fontSize: 'var(--font-size-xs)',letterSpacing:'2px',fontWeight:'700',color:'#555',marginBottom:'12px' }}>TIPO DI ISCRIZIONE</div>
          <div style={{ display:'flex', gap:'10px', marginBottom:'20px' }}>
            {[['ORDINARIO','Socio Ordinario','Quota standard, diritto di voto in assemblea'],['SOSTENITORE','Socio Sostenitore','Supporta l\'associazione senza diritto di voto']].map(([val,titolo,desc]) => (
              <label key={val} style={{ flex:1, display:'flex', alignItems:'flex-start', gap:'10px', background: form.tipo_richiesto===val?'#F4600C15':'var(--bg-input)', border:`1px solid ${form.tipo_richiesto===val?'#F4600C40':'var(--border2)'}`, borderRadius:'8px', padding:'12px', cursor:'pointer' }}>
                <input type="radio" name="tipo_richiesto" value={val} checked={form.tipo_richiesto===val} onChange={()=>setForm(f=>({...f,tipo_richiesto:val}))} style={{ accentColor:'#F4600C', marginTop:'2px', flexShrink:0 }}/>
                <div>
                  <div style={{ fontWeight:'700', fontSize: 'var(--font-size-sm)', color: form.tipo_richiesto===val?'#F4600C':'#ccc' }}>{titolo}</div>
                  <div style={{ fontSize: 'var(--font-size-xs)', color:'#666', marginTop:'2px' }}>{desc}</div>
                </div>
              </label>
            ))}
          </div>

          {/* Note */}
          <div style={{ marginBottom:'20px' }}>
            <label style={lab}>NOTE (opzionale)</label>
            <textarea style={{ ...inp, height:'70px', resize:'vertical' }} value={form.note_utente} onChange={e=>setForm(f=>({...f,note_utente:e.target.value}))} placeholder="Eventuali informazioni aggiuntive per la segreteria..."/>
          </div>

          {/* Consensi */}
          <div style={{ fontSize: 'var(--font-size-xs)',letterSpacing:'2px',fontWeight:'700',color:'#555',marginBottom:'12px' }}>DICHIARAZIONI E CONSENSI</div>
          <div style={{ display:'flex', flexDirection:'column', gap:'10px', marginBottom:'24px' }}>
            {[
              ['accetta_statuto', true,  'Ho letto e accetto integralmente lo Statuto dell\'Associazione, e mi impegno a rispettarne le regole e il regolamento interno. *'],
              ['accetta_privacy', true,  'Autorizzo il trattamento dei miei dati personali per finalità istituzionali (D.Lgs. 196/2003, GDPR 2016/679). *'],
              ['accetta_immagini', false, 'Autorizzo l\'utilizzo di fotografie e video che mi ritraggono durante le attività associative, per scopi istituzionali e promozionali (es. sito web, social media).'],
            ].map(([field, required, testo]) => (
              <label key={field} style={{ display:'flex', alignItems:'flex-start', gap:'10px', cursor:'pointer' }}>
                <input type="checkbox" checked={!!form[field]} onChange={e=>setForm(f=>({...f,[field]:e.target.checked}))}
                  style={{ accentColor:'#22C55E', width:'16px', height:'16px', marginTop:'2px', flexShrink:0 }}/>
                <span style={{ fontSize: 'var(--font-size-xs)', color:'#aaa', lineHeight:'1.5' }}>{testo}</span>
              </label>
            ))}
          </div>

          <button type="submit" disabled={saving || !form.accetta_statuto || !form.accetta_privacy}
            style={{ background:'#F4600C',color:'#fff',border:'none',borderRadius:'8px',padding:'13px 20px',fontSize: 'var(--font-size-sm)',fontWeight:'800',letterSpacing:'1px',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:'8px',opacity:(saving||!form.accetta_statuto||!form.accetta_privacy)?0.5:1 }}>
            <ChevronRight size={15}/>
            {saving ? 'INVIO IN CORSO...' : (puoReinviare ? 'REINVIA DOMANDA' : 'INVIA DOMANDA DI ISCRIZIONE')}
          </button>
        </form>
      )}
    </div>
  );
}
